import {
  ExportDropdown,
  ExportDropdownProps,
} from "@components/common/export/export-dropdown";
import { SdbTeam } from "@custom-types/teams-types";
import { useDateTime } from "@hooks/use-date-time";
import { TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
import { downloadTeamData, ExportFormat } from "@utils/file-data-export";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback } from "react";

interface Props extends Pick<ExportDropdownProps, "buttonType"> {
  /** List of selected teams in table */
  selectedTeams: SdbTeam[];

  /** True if some entities are selected */
  areEntitiesSelected: boolean;
}

/** Dropdown to export teams in the file format selected by the user */
export function BulkExportTeams({
  selectedTeams,
  areEntitiesSelected,
  buttonType = "bulk",
}: Props): JSX.Element {
  const { formatDate } = useDateTime();

  const exportHandler = useCallback(
    async (format: ExportFormat): Promise<number> => {
      return await downloadTeamData(selectedTeams, formatDate, format);
    },
    [selectedTeams, formatDate]
  );

  return (
    <ExportDropdown
      trackingProps={{
        dataType: TableType.teams,
        numberOfEntities: selectedTeams.length,
        areEntitiesSelected,
      }}
      exportHandler={exportHandler}
      toastMessage={{
        success: `Successfully exported ${TEAMS_DISPLAY_NAME}.`,
        error: `Cannot export ${TEAMS_DISPLAY_NAME}. Please try again.`,
      }}
      buttonTooltipText={`Export ${TEAMS_DISPLAY_NAME}`}
      buttonType={buttonType}
    />
  );
}
